import { BehaviorSubject } from 'rxjs';
import { IChatState } from '../chat.models'
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChatStateStoreService {
  private _initialState: IChatState = {
    applicationKey: 'Provider_Next_Gen',
    callerType: 'provider',
    chatTopic: '',
    dob: '',
    email: '',
    firstName: '',
    lastName: '',
    lobName: 'chat_testing',
    memberId: '',
    nickName: '',
    preferredName: '',
    providerNPI: '',
    subject: '',
    tpaClient: '',
    tpaDiv: '',
    tpaId: '',
    userId: '',
    vnumber: ''
  };
  private _stateSubject = new BehaviorSubject<IChatState>(this._initialState);
  
  chatState$ = this._stateSubject.asObservable();

  updateChatState(state: IChatState): void {
    this._stateSubject.next(state);
  }

  updatePartialChatState(partialState: Partial<IChatState>): void {
    const currentState = this._stateSubject.getValue();
    const newState = { ...currentState, ...partialState };
    
    this._stateSubject.next(newState);
  }
}
